import Signal from 'libs/signals';

const stateAddNoteSignal = Signal({
  id: Math.floor(Math.random() * 100),
  note: '',
  date: new Date(),
});

export default stateAddNoteSignal;
